// src/contexts/AuthContext.tsx

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface OverviewContextType {
  user: boolean;
}

const OverviewContext = createContext<OverviewContextType | undefined>(
  undefined,
);

// Create a provider component
export const OverviewProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isUser, setUser] = useState<boolean>(true);

  return (
    <OverviewContext.Provider
      value={{
        user: isUser,
      }}
    >
      {children}
    </OverviewContext.Provider>
  );
};

export const useOverview = (): OverviewContextType => {
  const context = useContext(OverviewContext);
  if (context === undefined) {
    throw new Error('useOverview must be used within a OverviewProvider');
  }
  return context;
};
